const USER_URL = process.env.API_URL + '/user/';
const USER_XUGARHERO_URL = process.env.API_URL + '/xugarhero/user/';

const getUsers = (context) => {
  return context.$http.get(USER_URL);
};

const createUser = (context, user) => {
  return context.$http.post(USER_URL, user);
};

const updateUser = (context, user) => {
  return context.$http.put(USER_URL, user);
};

const deleteUser = (context, id) => {
  return context.$http.delete(USER_URL, {params: {id: id}});
};

const updateUserPassword = (context, request) => {
  return context.$http.put(USER_URL + 'password', request);
};

const getEmailInfoByName = (context) => {
  return context.$http.get(USER_URL + 'email');
};

const setEmailInfoByName = (context, request) => {
  return context.$http.put(USER_URL + 'email', request);
};

const getUserProfile = (context, id) => {
  return context.$http.get(USER_XUGARHERO_URL + id);
};

export default {
  getUsers,
  createUser,
  updateUser,
  deleteUser,
  updateUserPassword,
  getEmailInfoByName,
  setEmailInfoByName,
  getUserProfile
};



// WEBPACK FOOTER //
// ./src/api/user/userHttp.js